import styled from 'styled-components';
import { DefaultTheme } from '../themes/DefaultTheme';

export const AutocompleteElement = styled.div`
  position: relative;
` as any;

export const FaceElement = styled.div`
  ${props => props.theme.partials.form.item.default};
  align-items: stretch;
` as any;

export const InputElement = styled.input`
  color: ${props => props.theme.vars.newColor.darkGS1};
  background-color: transparent;
  border: none;
  outline: none;
  flex: 1;
` as any;

export const MenuListElement = styled.ul`
  margin: 0;
  padding: 0;
  margin-top: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.3);
  max-height: ${({ menuHeight }: any) => menuHeight}px;
  border-radius: 5px;
  overflow: auto;
  position: absolute;
  left: 2px;
  right: 2px;
  z-index: 11;
  background-color: white;
  text-decoration: none;
  margin-bottom: 30px;
` as any;

export const MenuItemElement = styled.li`
  margin: 0;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  font-size: 16px;
  text-transform: none;
  box-shadow: none;
  padding: 0.8rem 1.1rem;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: normal;
  text-decoration: none;
  color: #1a1d1f;
  background-color: ${(props: any) => (props.isHighlighted ? DefaultTheme.dropdown.menuItem.hoverBgColor : 'white')};

  &:focus {
    outline: 0;
  }
` as any;

export const ButtonElement = styled.div`
  margin-left: 10px;
` as any;

export const MenuButtonElement = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  color: #647079;
  background: none;
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  :hover,
  :focus {
    background: ${props => props.theme.vars.newColor.lightGS2};
  }
  :focus {
    outline: none;
  }
` as any;
